import {Inject, Injectable} from "@angular/core";
import {countries} from "countries-list"
import {I18nServices} from "../i18n/i18n.service";
import {Subject} from "rxjs";
import {IS_BROWSER} from "../utils/injectiontokens";
import {LocalStorageService} from "../storage/local-storage.service";

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  protected selectedCountry = null;
  protected countries: any[] = [];
  public onCountrySelected$ = new Subject<any>();

  constructor(protected i18nServices: I18nServices,
              protected storageService: LocalStorageService,
              @Inject(IS_BROWSER) protected isBrowser: boolean) {

    let currentCountryIsoCode = null;
    if(this.i18nServices.getCountryIsoCode() != null) {
      currentCountryIsoCode = this.i18nServices.getCountryIsoCode();
    }

    if(this.isBrowser) {
      this.selectedCountry = this.storageService.getObject("country");
    }

    for (let code in countries) {
      let entry = countries[code];
      if(entry.phone.indexOf(',') == -1) {
        let country = {
          code: code,
          imageFile: code.toLowerCase() + '.svg',
          name: entry.name,
          native: entry.native,
          currency: entry.currency,
          phonePrefix: '+' + entry.phone
        };
        if(this.selectedCountry == null && code == currentCountryIsoCode) {
          this.selectedCountry = country;
          this.saveData();
        }
        this.countries.push(country);
      }
    }
    //not sort countries array by country name
    this.countries.sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      return 0;
    });

  }

  public getCountries() {
    return this.countries;
  }

  public getCountry(countryCode: string) {
    //country code can be the iso code or even the phone prefix
    let returnValue = null;
    this.countries.forEach(country => {
      if (country.code == countryCode) {
        returnValue = country;
      }
      else if(country.phonePrefix == countryCode) {
        returnValue = country;
      }
    });
    return returnValue;
  }

  public setSelectedCountry(countryIsoCode: string) {
    this.selectedCountry = this.getCountry(countryIsoCode);
    if(this.selectedCountry != null) {
      this.onCountrySelected$.next(this.selectedCountry);
      this.saveData();
    }
    else {
      console.error('Country not found', countryIsoCode);
    }
  }

  public getSelectedCountry() {
    return this.selectedCountry;
  }

  public getPhonePrefix(countryIsoCode: string) {
    return this.getCountry(countryIsoCode).phonePrefix;
  }

  public saveData() {
    if(this.isBrowser) {
      this.storageService.setObject('country', this.selectedCountry);
    }
  }


}
